<div class="container" (click)="addItem()">
  <g-img [src]="'assets/consumer/icon_add_filled.svg'"></g-img>
  Add Recipe
</div>